import React from "react";
import { useSearchParams } from "react-router-dom";

export default function Test() {
  const [title, setTitle] = React.useState("");
  const [search, setSearch] = "";
  const books1 = [
    {
      title: "The Road to Rust",
      isCompleted: false,
    },
    {
      title: "The Road to React",
      isCompleted: true,
    },
  ];
  const books = {
    // nodes: list.filter((item) => item.name.includes(search)),
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <h1>
          <label htmlFor="search">
            Search
            <input id="search" type="text" onChange={handleSearch} />
          </label>
          <ul>
            {/* {books.filter(byTitle(search.get("title"))).map((book) => (
              <li key={book.title}>{book.title}</li> */}
            {/* ))} */}
          </ul>
        </h1>
      </main>
    </>
  );
}
